<template>
  <!-- 设备信息 -->
  <div class="deviceinfo deviceoperateAdminNew">
    <!-- <span style="color:#fff;">{{deviceInfo}}</span> -->
    <!-- <span>role：{{this.$store.state.user.role}}</span> -->
    <!-- <span>username：{{this.$store.state.user.username}}</span> -->
    <!-- <span>经销商uid：{{this.$store.state.user.uidExtra}}</span> -->
    <!-- <span>切换账号uid：{{deviceInfo.uid}}</span> -->
    <!-- 设备-operate -->

    <div>
      <div class="deviceoperate">
        <span class="top-info">
          <span class="label">
            <i class="status-icon-shadow" :class="deviceStatus.class"></i>
          </span>
          <span class="namebox">
            <span class="name">
              {{ deviceInfo.devalias || deviceInfo.sn }}
              <!-- {{deviceInfo.devalias || '--'}} -->
            </span>
          </span>
          <el-button type="text" class="operation" style="color:@primaryTextColor;margin-left: 6px;"
            :title="$t('device.edit')" @click="editDevice(deviceInfo)">
            <i class="iconfont icon-bianji"></i>
            <!-- <i class="ico-edit"></i> -->
          </el-button>
        </span>
        <!-- 返回/详情 -->
        <!-- <span></span> -->

        <div class="top-operate aOperate">
          <div class="aRowOne">
            <!-- 返回设备总列表 -->
            <el-button class="todetail" @click="backDeviceListOne">{{ $t('project.back') }}</el-button>
            <!-- 查看详情(跳转我的设备页) -->
            <!-- @click="showDetail" -->
            <!-- @click="enterDevice(scope.row)" -->
            <el-button class="todetail" @click="enterDevice(deviceInfo)">{{ $t('device.detail') }}</el-button>

            <!-- 管理员是不进行关注与取消的(只是总览) -->
            <!-- <el-button
              type="text"
              class="operation"
              @click="followDevice(deviceInfo)"
            ><i class="icobase followno" :class="{'followyes': followactive}"></i><span class="icon-text1">{{followactive?$t('device.unfollow'):$t('device.follow')}}</span>
            </el-button>-->
            <!-- @click="exportDevice(deviceInfo.pn)" -->
            <el-button type="text" class="operation" @click="exportPlant([deviceInfo])">
              <i class="iconfont icon-baobiao1"></i>
              <!-- <i class="icobase ico-export"></i> -->
              <span class="icon-text1">{{ $t('device.report') }}</span>
            </el-button>
          </div>

          <div class="aRowTwo">
            <div class="aRowTwoBoxOne">
              <!-- <el-button
                type="text"
                class="operation"
                :title="$t('device.edit')"
                @click="editDevice(scope.row)"
              >
                <i class="iconfont icon-edit"></i>
              </el-button>-->
              <!-- :title="$t('device.debug')" -->
              <el-button type="text" class="operation" @click="debugDevice(deviceInfo)">
                <i class="iconfont icon-caozuo_tiaoshi"></i>
                <!-- <i class="icobase ico-debug"></i> -->
                <span class="icon-text1">{{ $t('device.debug') }}</span>
              </el-button>
              <!-- :title="$t('device.control')" -->
              <el-button type="text" class="operation" @click="controlDevice(deviceInfo)">
                <i class="iconfont icon-kongzhi"></i>
                <!-- <i class="icobase ico-control"></i> -->
                <span class="icon-text1">{{ $t('device.control') }}</span>
              </el-button>
            </div>

            <div class="aRowTwoBoxTwo">
              <!-- :title="$t('device.upgrade')" -->
              <el-button type="text" class="operation" @click="upgradeDevice(deviceInfo)">
                <i class="iconfont icon-shengji"></i>
                <!-- <i class="icobase ico-upgrade"></i> -->
                <span class="icon-text1">{{ $t('device.upDevice') }}</span>
              </el-button>
              <!-- 删除 (经销商[2]可删其所属[uid]) -->
              <!-- :title="$t('device.delete')" -->
              <!-- <el-button
                v-if="this.$store.state.user.role==2 && this.$store.state.user.uidExtra==deviceInfo.uid"
                type="text"
                class="operation delBgc"
                @click="deleteDevice(deviceInfo)"
              ><i class="iconfont icon-shanchu"></i><span class="icon-text1">{{$t('device.delete')}}</span>
              </el-button>-->
            </div>

          </div>
        </div>

      </div>
      <!-- 所属用户 -->
      <!-- deviceoperate -->
      <div class="usrBox">{{ `${$t('device.User_belong')} ：${deviceInfo.usr || '--'}` }}</div>
    </div>

    <!-- 设备-info -->
    <div class="infopanel">
      <!-- :data="deviceInfo" -->
      <div class="infobox">
        <!-- 基本信息 -->
        <div class="title aTitle1">{{ `1.${$t('datalogger.basic_info')}` }}</div>
        <div class="cell name light aCell11 splitHLine">{{ $t('device.device_sn') }}</div>
        <div class="cell data dark aCell12 splitHLine">{{ deviceInfo.deviceSn||deviceInfo.sn }}</div>
        <div class="aCell01 splitVBox"></div>
        <div class="cell name light aCell13 splitHLine">{{ $t('device.device_type') }}</div>
        <div class="cell data dark aCell14 splitHLine">{{ deviceInfo.brand | translateDeviceType }}</div>
        <div class="cell name light aCell21 splitHLine">{{ $t('device.device_model') }}</div>
        <div class="cell data dark aCell22 splitHLine">{{ deviceInfo.devtype || '--' }}</div>
        <div class="aCell02 splitVBox"></div>
        <div class="cell name light aCell23 splitHLine">{{ $t('device.device_code') }}</div>
        <div class="cell data dark aCell24 splitHLine">{{ deviceInfo.devcode }}</div>
        <div class="cell name light aCell31">{{ $t('datalogger.Firmware_Version') }}</div>
        <div class="cell data dark aCell32">{{ deviceInfo.device_Firmware_Version || '--' }}</div>
        <div class="aCell03 splitVBox"></div>
        <div class="cell name light aCell33">{{ $t('device.device_address') }}</div>
        <div class="cell data dark aCell34">{{ deviceInfo.devaddr }}</div>
        <!-- 所属数采器 -->
        <div class="title aTitle2">
          {{ `2.${$t('device.Datalogger_belong')}` }}
          <el-button class="todetail" @click="showDetail">{{ $t('device.detail') }}</el-button>
        </div>
        <div class="cell name light aCell41">{{ $t('device.coll_alias') }}</div>
        <div class="cell data dark aCell42">{{ deviceInfo.collalias }}</div>
        <div class="aCell04 splitVBox"></div>
        <div class="cell name light aCell43">{{ $t('device.datalogger_pn') }}</div>
        <div class="cell data dark aCell44">{{ deviceInfo.pn }}</div>
        <!-- 收益信息 -->
        <div class="title aTitle3">{{ `3.${$t('datalogger.income_info')}` }}</div>
        <!-- （a） -->
        <div class="cell name light aCell51">{{ `${$t('device.Today_income')}` }}</div>
        <div class="cell data dark aCell52">{{ deviceInfo.profitToday | formatNum(2) }}</div>
        <div class="aCell05 splitVBox"></div>
        <!-- （a） -->
        <div class="cell name light aCell53">{{ `${$t('device.Cumulative_income')}` }}</div>
        <div class="cell data dark aCell54">{{ deviceInfo.profitTotal | formatNum(2) }}</div>
      </div>
      <!-- 设备-operate2 -->
      <!-- <div class="attachbox"></div> -->
    </div>

    <!-- 弹窗系列 -->

    <!-- 导出报表 -->
    <export-plant-dialog :params.sync="exportPlantParams"></export-plant-dialog>

    <!-- 编辑设备 -->
    <!-- v-if="editDeviceVisible" -->
    <device-dialog :title="$t('device.modify_alias')" :visible.sync="editDeviceVisible"
      :class="{ 'showDialog': editDeviceVisible, 'hideDialog': !editDeviceVisible }" noFooter>
      <div slot="content">
        <el-form class="grid">
          <!-- <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
              <el-input v-model="formEdit.sn" disabled></el-input>
          </el-form-item>-->
          <!-- <el-form-item :label="$t('device.device_code_form')" prop="devcode" size="small">
              <el-input v-model="formEdit.devcode" disabled></el-input>
          </el-form-item>-->
          <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
            <el-input v-model="formEdit.devalias" clearable></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button class="btn btn-dark" @click="submitEditDevice">{{ $t('device.confirm') }}</button>
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-hollow" @click="editDeviceVisible = false">{{$t('device.cancel')}}</button> -->
        <!-- <button class="button-solid" @click="submitEditDevice">{{$t('device.confirm')}}</button> -->
      </div>
    </device-dialog>
    <!-- 修改设备结果提示(成功) -->
    <!-- v-if="editDeviceSucVisible" -->
    <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceSucVisible"
      :class="{ 'showDialog': editDeviceSucVisible, 'hideDialog': !editDeviceSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('project.editSuc') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editDeviceSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 修改设备结果提示(失败) -->
    <!-- v-if="editDeviceFailVisible" -->
    <device-dialog :title="$t('project.editResults')" :visible.sync="editDeviceFailVisible"
      :class="{ 'showDialog': editDeviceFailVisible, 'hideDialog': !editDeviceFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="editDeviceFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 逆变器调试 -->
    <!-- v-if="debugDeviceVisible" -->
    <device-dialog :title="$t('device.debug')" :visible.sync="debugDeviceVisible"
      :class="{ 'showDialog': debugDeviceVisible, 'hideDialog': !debugDeviceVisible }" noFooter>
      <div slot="content">
        <el-form slot="content" class="grid">
          <el-form-item :label="$t('device.Device_pn')" size="small">
            <el-input v-model="device.pn" auto-complete="off" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('device.Instruction')" size="small">
            <el-input v-model="devDebug.cmd" :placeholder="$t('device.such_as')" type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }" auto-complete="off"></el-input>
          </el-form-item>
          <!-- 发送指令 -->
          <el-form-item label=" ">
            <div style="text-align:right;">
              <button class="btn btn-dark" type="button" @click="submitDebugDevice()">{{ $t('device.send') }}</button>
            </div>
          </el-form-item>
          <el-form-item :label="$t('device.return_content')" size="small">
            <div class="debug-return">
              <!-- id="link" -->
              <el-input readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
              <div class="return-tool">
                <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                  data-clipboard-target="#link">
                  <i class="ico ico-copy"></i>
                  {{ $t('device.copy_val') }}
                </span>
                <span class="btn" @click="qingkong()">
                  <i class="ico ico-clear"></i>
                  {{ $t('device.clear_val') }}
                </span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <!-- <button 
            class="button-hollow" 
            @click="qingkong()"
        >{{$t('device.clear_data')}}</button>-->
        <!-- <button
            class="button-solid"
            type="primary"
            @click="submitDebugDevice()"
        >{{$t('device.send')}}</button>-->
      </div>
    </device-dialog>
    <!-- 控制项 -->
    <!-- v-if="controlDeviceVisible" -->
    <device-dialog :title="$t('device.control')" :width="'910px'"
      :class="{ 'showDialog': controlDeviceVisible, 'hideDialog': !controlDeviceVisible }"
      :visible.sync="controlDeviceVisible" noFooter>
      <div class="control tableloding" slot="content">
        <div v-if="tableDataBse.length">
          <div class="tableTitle">{{ $t('createPlant.basic_settings') }}</div>
          <el-table :data="tableDataBse" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataStd.length">
          <div class="tableTitle">{{ $t('createPlant.Standard_setting') }}</div>
          <el-table :data="tableDataStd" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataSvs.length">
          <div class="tableTitle">{{ $t('createPlant.System_settings') }}</div>
          <el-table :data="tableDataSvs" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataPvs.length">
          <div class="tableTitle">{{ $t('createPlant.Solar_settings') }}</div>
          <el-table :data="tableDataPvs" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataGrd.length">
          <div class="tableTitle">{{ $t('createPlant.Grid_settings') }}</div>
          <el-table :data="tableDataGrd" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataBat.length">
          <div class="tableTitle">{{ $t('createPlant.Battery_settings') }}</div>
          <el-table :data="tableDataBat" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataCts.length">
          <div class="tableTitle">{{ $t('createPlant.Control_settings') }}</div>
          <el-table :data="tableDataCts" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataLos.length">
          <div class="tableTitle">{{ $t('createPlant.Load_setting') }}</div>
          <el-table :data="tableDataLos" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataBas.length">
          <div class="tableTitle">{{ $t('createPlant.Basic_setting') }}</div>
          <el-table :data="tableDataBas" stripe border :empty-text="$t('message.nodata')">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataAdv.length">
          <div class="tableTitle">{{ $t('createPlant.Advanced_setting') }}</div>
          <el-table :data="tableDataAdv" stripe border :empty-text="$t('message.nodata')">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataElse.length">
          <div class="tableTitle">{{ $t('createPlant.other_settings') }}</div>
          <el-table :data="tableDataElse" stripe border :empty-text="$t('message.nodata')" :cell-style="changeCellStyle">
            <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px">
              <template slot-scope="scope">
                <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length"
                  popper-class="select-search-recharge">
                  <el-option v-for="item in scope.row.controlinter" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <el-input v-model="scope.row.controlvalue" v-else-if="scope.row.hint"
                  :placeholder="scope.row.hint"></el-input>
                <el-input v-model="scope.row.controlvalue"
                  :placeholder="scope.row.id === 'system_time' && 'yyyy-MM-dd hh:mm:ss'" v-else></el-input>
              </template>
            </el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')">
              <template slot-scope="scope">
                <div class="current-value">
                  <el-input :disabled="true" v-model="scope.row.dangqianzhi"></el-input>
                  <el-button :title="$t('device.obtain')" v-loading="scope.row.isLoading"
                    @click="huoquInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-shuaxin"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <!-- element-loading-spinner="el-icon-loading" -->
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverter(scope.row)" class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="tableDataHuangJinTai.length">
          <div class="tableTitle">{{ $t('createPlant.Battery_settings') }}</div>
          <el-table :data="tableDataHuangJinTai" stripe border :empty-text="$t('message.nodata')"
            :cell-style="changeCellStyle">
            <el-table-column :label="$t('device.Battery_voltage')">
              <template slot-scope="scope">
                <el-select v-model="scope.row.voltage" @change="huangjintaiChange">
                  <el-option label="12V" :value="12"></el-option>
                  <el-option label="24V" :value="24"></el-option>
                  <el-option label="48V" :value="48"></el-option>
                  <el-option label="96V" :value="96"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('device.Magnification')">
              <template slot-scope="scope">
                <el-input disabled v-model="scope.row.multiply"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('device.Send_Command')">
              <template slot-scope="scope">
                <div class="control-value">
                  <!-- element-loading-spinner="el-icon-loading" -->
                  <el-button v-loading="scope.row.Loading" @click="xiafaInverterHuangJinTai(scope.row)"
                    class="submit-control">
                    <i class="iconfont icon-caozuo_tiaoshi"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 无数据 -->
        <div v-if="noDataControl">
          <el-table height="50vh" stripe border :empty-text="$t('message.nodata')">
            <el-table-column :label="$t('device.Field_Name')"></el-table-column>
            <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
            <el-table-column width="220px" :label="$t('device.current_val')"></el-table-column>
            <el-table-column :label="$t('device.Unit')"></el-table-column>
            <el-table-column :label="$t('device.Send_Command')"></el-table-column>
          </el-table>
        </div>
      </div>
    </device-dialog>

    <!-- 固件升级 -->
    <!-- v-if="upgradeDeviceVisible" -->
    <device-dialog :title="$t('device.device_upgrade')" :visible.sync="upgradeDeviceVisible"
      :class="{ 'showDialog': upgradeDeviceVisible, 'hideDialog': !upgradeDeviceVisible }" width="580px" noFooter>
      <div slot="content">
        <el-form class="grid upload-container upgradeNew">
          <el-form-item :label="$t('device.select_firmware')" size="small">
            <el-select v-model="searchrecharge.firmware" @change="voltageArr($event)"
              :placeholder="$t('device.select_file')" popper-class="select-search-recharge select-search-project">
              <template slot="empty">
                <div style="text-align:right;">
                  <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') }}</button>
                </div>
              </template>
              <div style="text-align:right;">
                <button class="upFirewareBtn" @click="dialogAdd = true;">{{ $t('firmware.Upload_firmware') }}</button>
              </div>
              <el-option v-for="item in rechargelist" :key="item.value" :label="item.firmware"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.firmware_type')" size="small">
            <el-select v-if="!hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
              popper-class="select-search-recharge">
              <el-option v-for="item in firmwaretypelist" :key="item.id" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select v-if="hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
              popper-class="select-search-recharge">
              <el-option v-for="item in firmwaretypelist1" :key="item.id" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.upgrade_brate')" size="small">
            <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')"
              popper-class="select-search-recharge">
              <el-option v-for="item in bratelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <div class="processstatueEquipment" v-show="progressUp">{{ $t('firmware.upgrading') }}</div>
            <div class="processstatueEquipment" v-show="progerssComplete">{{ $t('firmware.updateCompleted') }}</div>
            <!-- 原上传按钮 -->
            <!-- <div class="upload-contents">
                <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                  <i class="iconfont icon-shangchuan"></i>
                  {{$t('device.Upload')}}
                </button>
                <div class="upload-tip">{{$t('firmware.limit')}}</div>
            </div>-->
            <div class="progressShowEquipment" v-show="progressUp">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel" @click="upgradeCancel">
                <i class="iconfont icon-delete"></i>
              </div>
            </div>
            <div class="processDataEquipment" v-show="progressUp">
              <el-progress :format="progressText" :percentage="progress" :stroke-width="10"></el-progress>
              <div class="processBig">{{ uploadNowSize }}M / {{ uploadTotalSize }}M</div>
            </div>
            <!-- 原上传按钮 -->
            <!-- <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept="application/octet-stream"
                @change="uploadfile($event)"
            />-->
            <div class="progerssCompleteEquipment" v-show="progerssComplete">
              <div class="progressName">
                <i class="iconfont icon-fujian"></i>
                {{ firmwareName }}
              </div>
              <div class="progressCancel"></div>
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button class="btn btn-dark" @click="submitUpgradeDevice">{{ $t('device.confirm') }}</button>
        </div>
      </div>
      <div slot="footer">
        <!-- <button
            class="button-hollow"
            @click="upgradeDeviceVisible = false"
        >{{$t('device.cancel')}}</button>-->
        <!-- <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button> -->
      </div>
    </device-dialog>
    <!-- 固件升级二次弹窗（增加固件的对话框） -->
    <!-- style="z-index:2014!important;" -->
    <!-- v-if="dialogAdd" -->
    <!-- :class="{'showDialog': dialogAdd, 'hideDialog': !dialogAdd}" -->
    <update-dialog :title="$t('firmware.Upload_firmware')" v-if="dialogAdd" :visible.sync="dialogAdd" width="40vw"
      noFooter style="z-index:3000;">
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item :label="$t('firmware.Firmware_description')" size="small">
            <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                <!-- {{$t('datalogger.Upload')}} -->
              </button>
              <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
              <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button class="btn btn-dark" @click="dialogAdd = false">{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </update-dialog>
    <!-- 升级结果提示(成功) -->
    <!-- v-if="upgradeDeviceSucVisible" -->
    <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceSucVisible"
      :class="{ 'showDialog': upgradeDeviceSucVisible, 'hideDialog': !upgradeDeviceSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('datalogger.modifySuc')}}</span> -->
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="upgradeDeviceSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 升级结果提示(失败) -->
    <!-- v-if="upgradeDeviceFailVisible" -->
    <device-dialog :title="$t('datalogger.editResults')" :visible.sync="upgradeDeviceFailVisible"
      :class="{ 'showDialog': upgradeDeviceFailVisible, 'hideDialog': !upgradeDeviceFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="upgradeDeviceFailVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </device-dialog>

    <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="deletingDeviceInfo" -->
    <device-dialog :title="$t('device.deleteDevice')" :visible.sync="deletingDeviceInfo"
      :class="{ 'showDialog': deletingDeviceInfo, 'hideDialog': !deletingDeviceInfo }" width="30vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('device.confirm_deldte') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('account.notRecovered') }}</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button class="btn btn-dark" style="margin-right:10px;" @click="submitDeleteDevice">{{ $t('device.confirm')
          }}</button>
          <button class="btn btn-light" @click="deletingDeviceInfo = null">{{ $t('device.cancel') }}</button>
        </div>
      </div>
    </device-dialog>
    <!-- 删除设备结果提示(成功) -->
    <!-- v-if="delDeviceSucVisible" -->
    <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceSucVisible"
      :class="{ 'showDialog': delDeviceSucVisible, 'hideDialog': !delDeviceSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('project.delSuc') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delDeviceSucVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
    <!-- 删除设备结果提示(失败) -->
    <!-- v-if="delDeviceFailVisible" -->
    <device-dialog :title="$t('project.delResults')" :visible.sync="delDeviceFailVisible"
      :class="{ 'showDialog': delDeviceFailVisible, 'hideDialog': !delDeviceFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ deviceTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button class="btn btn-dark" @click="delDeviceFailVisible = false;">{{ $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </device-dialog>
  </div>
</template>
<script>
// import { mapGetters } from 'vuex';
import { mapGetters,mapState } from 'vuex';
import deviceDialog from "@/components/dialognew";
import updateDialog from "@/components/dialognew/flowIndex";
import exportPlantDialog from "@/components/dialognew/exportPlant";
import clipboard from "@/assets/js/clipboard";
import { i18n } from "@/i18n";
// import config from "@/assets/js/config";
export default {
  components: {
    deviceDialog,
    exportPlantDialog,
    updateDialog
  },
  // props: {
  //   queryData: {
  //     type: Object
  //   }
  // },
  data () {
    return {
      hideFlag: false,//德业域名显隐
      deviceInfoTest: [],
      noDataControl: false,
      emptyText: false,
      paginationControl: false,
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        brand: "",
        pn: "",
        search: ""
      },
      xieyi: [],
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0"
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelist: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
      ],
      firmwaretypelist1: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id: 15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id: 16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0"
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400"
        },
        {
          label: 4800,
          value: "4800"
        },
        {
          label: 9600,
          value: "9600"
        },
        {
          label: 19200,
          value: "19200"
        },
        {
          label: 38400,
          value: "38400"
        },
        {
          label: 57600,
          value: "57600"
        },
        {
          label: 115200,
          value: "115200"
        }
      ],
      loadingdevice: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      }, //分页数据
      deviceList: [],
      selectedAlarm: [], //批量删除
      tableDataBse: [],
      tableDataStd: [],
      tableDataSvs: [],
      tableDataPvs: [],
      tableDataGrd: [],
      tableDataBat: [],
      tableDataCts: [],
      tableDataLos: [],
      tableDataBas: [],
      tableDataAdv: [],
      tableDataElse: [],
      tableDataHuangJinTai: [], //黄金台定制
      controlinter: [],
      controlvalue: "",
      editDeviceVisible: false,
      editDeviceInfo: null,
      debugDeviceVisible: false,
      debugDeviceId: null,
      upgradeDeviceVisible: false,
      upgradeDeviceterId: null,
      deletingDeviceInfo: null,
      controlDeviceVisible: false,
      statisticDialogVisible: false, //统计弹窗是否可见
      // 编辑设备
      formEdit: {
        sn: "",
        pn: "",
        devaddr: "",
        devcode: "",
        // alias: "",
        devalias: ""
      },
      device: {
        pn: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
      // 是否关注
      followactive: false,
      // 导出报表
      exportPlantParams: [],
      // 显示上传固件二层弹窗
      dialogAdd: false,
      desc: "",
      // 修改设备成功提示
      editDeviceSucVisible: false,
      // 修改设备失败提示
      editDeviceFailVisible: false,
      // 删除设备成功提示
      delDeviceSucVisible: false,
      // 删除设备失败提示
      delDeviceFailVisible: false,
      // 升级设备成功提示
      upgradeDeviceSucVisible: false,
      // 升级设备失败提示
      upgradeDeviceFailVisible: false,
      // 操作返回提示
      deviceTipMsg: "",
      // 该设备信息(新)
      deviceOwnInfo: {},
      // 显示数采器页
      showDevicebelong: false,
      // 设备信息
      // deviceOwnInfo: {
      //   // brand: "",
      //   // collalias: "",
      //   // devaddr: "",
      //   // devalias: "",
      //   // devcode: "",
      //   // devtype: "",
      //   // pid: "",
      //   // pn: "",
      //   // profitToday: "",
      //   // profitTotal: "",
      //   // sn: "",
      //   // status: "",
      //   // uid: "",
      //   // usr: "",
      // }
    };
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo"
    }),
    deviceStatus () {
      // return this.$filter.deviceStatus[this.deviceInfo.status]
      return this.$filter.deviceStatusShadow[this.deviceInfo.status];
    },
             ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  watch: {
    // deleteDeviceVisible(val) {
    //   if (!val) this.deletingDeviceInfo = null;
    // },
    upgradeDeviceVisible (val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    },
    deviceInfo: {
      handler () {
        this.followactive = this.deviceInfo.focus;
        // this.getDeviceOwnInfo();
        // console.log("watch->deviceInfo-val", val)
      },
      deep: true
    },
    followactive: {
      handler () {
        this.followactive = this.deviceInfo.focus;
      },
      immediate: true
    },
    // 响应更新电站列表事件
    "$store.state.event.updateFocus" (val) {
      if (val) {
        this.changeFocus();
        this.$store.state.event.updateFocus = false;
      }
    }
  },
  created () {
    // this.getDeviceList();
    this.getDeviceOwnInfo();
    this.showHides();
  },
  methods: {
    //德业域名
    showHides () {
      var hostname = window.location.hostname;
      if (hostname == "deye.dessmonitor.com") {
        this.hideFlag = true
      }
    },
    changeFocus () {
      this.$set(this.deviceInfo, "focus", !this.deviceInfo.focus);
      this.followactive = this.deviceInfo.focus;
    },
    // 关注 (info)
    // pn/sn/devaddr/devcode/focus(true,false)
    followDevice (info) {
      // this.focus = !this.focus;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        // focus: info.focus == undefined ? false : deviceInfo.focus,
        focus: !info.focus
      };
      // console.log('关注param', param);
      this.$request.get("editDeviceFocusEs", param).then(res => {
        if (res.err === 0) {
          // this.followactive = param.focus;
          // console.log('关注成功followactive', this.followactive);
          // this.deviceInfo.focus = !info.focus;
          this.$set(this.deviceInfo, "focus", !info.focus);
          this.followactive = this.deviceInfo.focus;
          this.$store.commit("saveDeviceInfo", {
            pn: info.pn,
            sn: info.sn,
            deviceSn: info.deviceSn || info.sn,
            devalias: info.devalias,
            devcode: info.devcode,
            devaddr: info.devaddr,
            status: info.status,
            profitToday: info.profitToday,
            profitTotal: info.profitTotal,
            sellProfitToday: info.sellProfitToday,
            sellProfitTotal: info.sellProfitTotal,
            buyProfitToday: info.buyProfitToday,
            buyProfitTotal: info.buyProfitTotal,
            focus: !info.focus
            // pid: deviceInfo.pid,
          });
          // 通知项目列表更新
          this.$store.state.event.updateProjectList = true;
        } else {
          // console.log('关注失败', res.err);
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 导出报表
    // exportDevice() {},
    exportPlant (exportPlantParams) {
      if (!exportPlantParams.length) return false;
      this.exportPlantParams = exportPlantParams;
    },
    progressText (progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    //获取表格数据
    // getDeviceList(reset) {
    //   this.paginationControl = false;
    //   if (reset) this.pagination.currentPage = 1;
    //   let param = {
    //     ...this.search,
    //     devtype: 2304,
    //     page: this.pagination.currentPage - 1,
    //     pagesize: this.pagination.pagesize
    //   };
    //   this.loadingdevice = true;
    //   this.$request.get("webQueryDeviceEs", param).then(res => {
    //     if (res.err == 0) {
    //       this.deviceList = res.dat.device;
    //       this.pagination.total = res.dat.total;
    //       if (this.pagination.total > this.pagination.pagesize) {
    //         this.paginationControl = true;
    //       }
    //     } else {
    //       // this.$message.warning(this.$t(`errCode.${res.err}`));
    //       this.emptyText = true;
    //       this.deviceList = [];
    //       this.pagination.total = 0;
    //     }
    //     this.loadingdevice = false;
    //   });
    // },
    // 获取设备信息
    getDeviceOwnInfo () {
      let param = {
        sn: this.deviceInfo.sn,
        // devtype: 2304,
      };
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0) {
          // 新接口返回值转换为旧接口设备列表结构
          this.deviceOwnInfo = this.Fnreturndev(res)[0] || {};
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 点击进入设备（跳转我的设备页）
    // enterDevice(info) {
    //   this.$store.commit("saveDeviceInfo", {
    //     pn: info.pn,
    //     sn: info.sn,
    //     devcode: info.devcode,
    //     devaddr: info.devaddr,
    //     devalias: info.alias
    //   });
    // },
    enterDevice (info) {
      // 根据当前新旧版标识决定跳转页
      // let toPath = "";
      // if (this.$store.state.user.isNewEdition){
      //   toPath = "/generalNew/home";
      // } else {
      //   toPath = "/general/home";
      // }

      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            // console.log('管理员进入设备', res.dat)
            let routeUrl = this.$router.resolve({
              // path: toPath,
              // path: "/general/home",
              path: "/generalNew/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn,
                pid: info.pid,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 点击返回设备列表总表
    backDeviceListOne () {
      // 通知显示table(隐藏设备信息页)
      this.$emit("noticeDeviceBoxOne", true);

      // 通知当前激活设备列表按钮
      this.$emit("noticeDeviceBtn", 1);

      // console.log("send:device-single->table");
      // 清空所存store(暂未发现必须)
    },
    // 编辑设备
    editDevice (info) {
      // console.log("editDevice-info", info);
      this.editDeviceVisible = true;
      this.formEdit = { ...info, devalias: info.devalias };
      // console.log("editDevice-this.formEdit", this.formEdit);
    },
    // 确定修改逆变器
    submitEditDevice () {
      // console.log("submitEditDevice->this.formEdit", this.formEdit);
      // return;
      // let param = {
      //   pn: this.formEdit.pn,
      //   sn: this.formEdit.sn,
      //   devaddr: this.formEdit.devaddr,
      //   devcode: this.formEdit.devcode,
      //   alias: this.formEdit.devalias,
      // };
      const deviceInfoNew = { ...this.formEdit };
      let param = {
        pn: deviceInfoNew.pn,
        sn: deviceInfoNew.sn,
        devaddr: deviceInfoNew.devaddr,
        devcode: deviceInfoNew.devcode,
        alias: deviceInfoNew.devalias
      };
      this.$request.get("editDeviceInfo", param).then(res => {
        if (res.err == 0) {
          // this.$message.success(this.$t("device.modifySuc"));
          this.editDeviceVisible = false;
          this.editDeviceSucVisible = true;
          // window.location.reload();
          // 通知侧栏项目列表更新
          this.$store.state.event.updateProjectList = true;
          // 通知设备列表更新
          this.$store.state.event.updateDeviceList = true;
          // this.getDeviceList();
          // this.deviceInfo = {...deviceInfoNew};
          // console.log("deviceInfoNew", deviceInfoNew);
          // console.log("submitEditDevice-beforeCommit");
          // this.$store.commit("saveDeviceInfo", {
          //   devalias: deviceInfoNew.devalias,
          //   pn: deviceInfoNew.pn,
          //   sn: deviceInfoNew.sn,
          //   devcode: deviceInfoNew.devcode,
          //   devaddr: deviceInfoNew.devaddr,
          //   usr: deviceInfoNew.usr,
          //   uid: deviceInfoNew.uid,
          //   status: deviceInfoNew.status,
          //   focus: deviceInfoNew.focus,
          //   pid: deviceInfoNew.pid,
          // });
          this.$store.commit("saveDeviceInfo", {
            devalias: deviceInfoNew.devalias,
            usr: deviceInfoNew.usr,
            uid: deviceInfoNew.uid
          });
          this.formEdit = {};
          // console.log("submitEditDevice-afterCommit");
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.deviceTipMsg = this.$t(`errCode.${res.err}`);
          this.editDeviceFailVisible = true;
        }
      });
    },
    // 调试设备
    debugDevice (info) {
      this.devDebug.cmd = null;
      this.debugReturn = null;
      this.debugDeviceVisible = true;
      // this.debugDeviceId = id;
      this.$request
        .get("queryDeviceInfo", {
          device:
            info.pn + "," + info.devcode + "," + info.devaddr + "," + info.sn
        })
        .then(res => {
          if (res.err === 0) {
            // this.debugDeviceVisible = true,
            // this.getDeviceList();
            this.device = res.dat[0];
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // 发送指令
    submitDebugDevice () {
      if (this.device.status == "1") {
        this.$message.error(this.$t("device.Debugfail"));
      } else {
        this.debugReturn = this.$t("device.instruction_response");
        let param = {
          pn: this.device.pn,
          devaddr: this.device.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.debug_suc"));
            this.debugReturn = res.dat.dat;
            // this.debugDeviceVisible = false;
            // this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 控制项
    controlDevice (info) {
      this.controlDeviceVisible = true;
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      i18n: this.$lang.currentLang,
             role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then(res => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          let arr1 = [],
            arr2 = [],
            arr3 = [],
            arr4 = [],
            arr5 = [],
            arr6 = [],
            arr7 = [],
            arr8 = [],
            arr9 = [],
            arr10 = [],
            arr11 = [];
          tableData.forEach(field => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach(item => {
                field.controlinter.push({
                  label: item.val,
                  value: item.key
                });
              });
              //默认显示第一项
              // field.controlvalue = field.item.length ? field.controlinter[0].value: "";
              //不显示任由选择
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              arr1.push(field);
            } else if (s.startsWith("std_")) {
              arr2.push(field);
            } else if (s.startsWith("sys_")) {
              arr3.push(field);
            } else if (s.startsWith("pvs_")) {
              arr4.push(field);
            } else if (s.startsWith("grd_")) {
              arr5.push(field);
            } else if (s.startsWith("bat_")) {
              arr6.push(field);
            } else if (s.startsWith("cts_")) {
              arr7.push(field);
            } else if (s.startsWith("los_")) {
              arr8.push(field);
            } else if (s.startsWith("bas_")) {
              arr10.push(field)
            } else if (s.startsWith("adv_")) {
              arr11.push(field)
            } else {
              arr9.push(field);
            }
            // this.huoquInverter(field)
          });
          this.tableDataAdv = arr11;
          this.tableDataBas = arr10;
          this.tableDataElse = arr9;
          this.tableDataLos = arr8;
          this.tableDataCts = arr7;
          this.tableDataBat = arr6;
          this.tableDataGrd = arr5;
          this.tableDataPvs = arr4;
          this.tableDataSvs = arr3;
          this.tableDataStd = arr2;
          this.tableDataBse = arr1;
        } else {
          this.noDataControl = true;
          this.tableDataAdv = [];
          this.tableDataBas = [];
          this.tableDataElse = [];
          this.tableDataLos = [];
          this.tableDataCts = [];
          this.tableDataBat = [];
          this.tableDataGrd = [];
          this.tableDataPvs = [];
          this.tableDataSvs = [];
          this.tableDataStd = [];
          this.tableDataBse = [];
        }
      });
      //黄金台设备调用下方黄金台定制funtcion
      if (info.devcode == 2384) {
        this.getHuangjintaiControl(info);
      } else if (info.devcode == 2366) {
        this.getHuangjintaiControl(info);
      } else {
        this.tableDataHuangJinTai = [];
      }
    },
    //黄金台定制,获取电池电压和倍率
    getHuangjintaiControl (info) {
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr
      };
      this.$request.get("queryCtrlHuangJinTaiView", param).then(res => {
        if (res.err == 0) {
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: res.dat.voltage,
            multiply: res.dat.multiply
          });
        } else if (res.err == 8) {
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: 12,
            multiply: 0.09
          });
        } else {
          this.tableDataHuangJinTai = [];
        }
      });
    },
    huangjintaiChange (val) {
      var volArr = [
        { key: "12V", val: 12 },
        { key: "24V", val: 24 },
        { key: "48V", val: 48 },
        { key: "96V", val: 96 }
      ];
      var mulArr = [
        { key: "0.09", val: 0.09 },
        { key: "0.18", val: 0.18 },
        { key: "0.36", val: 0.36 },
        { key: "0.72", val: 0.72 }
      ];
      volArr.forEach((element, index) => {
        if (element.val == val) {
          this.tableDataHuangJinTai[0].multiply = mulArr[index].val;
        }
      });
    },
    // 控制项获取当前值
    huoquInverter (info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        id: info.id,
        i18n: this.$lang.currentLang
      };
      this.$set(info, "isLoading", true);
      // info.isLoading = true;
      this.$request.get("queryDeviceCtrlValue", param).then(res => {
        if (res.err == 0) {
          // info.dangqianzhi = res.dat.val;
          this.$set(info, "dangqianzhi", res.dat.val);
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.isLoading = false;
        this.$set(info, "isLoading", false);
      }).catch(() => {
          this.$set(info, "isLoading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
    },
    // 下发指令(黄金台)
    xiafaInverterHuangJinTai (info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        voltage: info.voltage,
        multiply: info.multiply
      };
      // info.Loading = true;
      this.$set(info, "Loading", true);
      this.$request.get("ctrlHuangJinTaiView", param).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t("device.Send_suc"));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.Loading = false;
        this.$set(info, "Loading", false);
      });
    },
    // 下发指令
    xiafaInverter (info) {
      if (!info.controlvalue) {
        this.$message.error(this.$t("device.Send_Input"));
      } else {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          val: info.controlvalue,
          i18n: this.$lang.currentLang
        };
        this.$set(info, "Loading", true);
        // info.Loading = true;
        this.$request.get("ctrlDevice", param).then(res => {
          // this.$request.get("ctrlDevice", param).then(res => {
          if (res.err == 0) {
            if (this.controlparams.devcode == 2352) {
              var medium = res.dat.dat.substring(27, 29);
              if (medium == "31") {
                this.$message.success(this.$t("device.Send_suc"));
              } else {
                this.$message.error(this.$t("device.Send_fail"));
              }
            } else {
              this.$message.success(this.$t("device.Send_suc"));
            }
          } else {
            if (this.controlparams.devcode == 2376) {
              if (res.desc.match(/\(([^)]*)\)/)) {
                this.$message.error(res.desc.match(/\(([^)]*)\)/)[1]);
              } else {
                const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
              }
            } else {
              const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
              this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
            }
            // this.$message.error(this.$t(`errCode.${res.err}`));
          }
          // info.Loading = false;
          this.$set(info, "Loading", false);
        }).catch(() => {
          this.$set(info, "Loading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
      }
    },
    voltageArr (item) {
      this.rechargelist.forEach(element => {
        if (element.id == item) {
          this.searchrechargeContents = element;
        }
      });
    },
    // 设备固件升级
    upgradeDevice (info) {
      this.queryFirmware();
      this.upgradeDeviceVisible = true;
      this.dataparams = info;
      this.progerssComplete = false;
    },
    // 查询固件列表
    queryFirmware () {
      this.searchrecharge.firmware = null;
      this.rechargelist = [];
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then(res => {
        if (res.code == 0) {
          res.data.items.forEach(item => {
            this.rechargelist.push({
              id: item.id,
              firmware: item.firmware,
              size: item.size
            });
          });
        }
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("device.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("device.error1"));
        return;
      }
      this.$request.uploadfileAxios(file).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
          // this.upgradeDeviceVisible = false;
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
          // 关闭二次弹窗
          this.dialogAdd = false;
        }
        this.queryFirmware();
        // this.upgradeDeviceVisible = false;
      });
    },
    // 确认固件升级
    submitUpgradeDevice () {
      // console.log("this.searchrechargeContents", this.searchrechargeContents);
      this.progress = 0;
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
      } else if (this.dataparams.status == "1") {
        this.$message.error(this.$t("device.updatefail"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              // this.$message.success(this.$t("device.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));

              // this.deviceTipMsg = this.$t("device.Upgrading");
              // this.upgradeDeviceSucVisible  = true;
              this.queryProgress();

              // this.upgradeDeviceVisible = false;
              // this.dialogAdd = false;
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              // this.deviceTipMsg = this.$t("device.System_Failed");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              // this.deviceTipMsg = this.$t("device.Device_Offline");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              // this.deviceTipMsg = this.$t("device.In_Upgrading");
              // this.upgradeDeviceFailVisible = true;
            }
            // this.upgradeDeviceVisible = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            // this.deviceTipMsg = this.$t(`errCode.${res.code}`);
            // this.upgradeDeviceFailVisible = true;
          }
        });
      }
    },
    // 查询升级进度
    queryProgress () {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        pn: this.dataparams.pn,
        devaddr: this.dataparams.devaddr,
        devcode: this.dataparams.devcode,
        sn: this.dataparams.sn,
        key: this.keyProgress
      };
       // 如果已存在定时器，先清除
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + "%";
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));
                  setTimeout(() => {
                    this.upgradeDeviceVisible = false;
                  }, 2000);
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
            }
          });
      }, 2000);
    },
    //取消升级
    upgradeCancel () {
      this.$request.putUPG("/upg/api/auth/web/shineDess/device/upgrade/deviceCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
    },
    deleteDevice (info) {
      this.deletingDeviceInfo = {
        pn: info.pn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        sn: info.sn
      };
    },
    // 确定删除设备
    submitDeleteDevice () {
      this.$request
        .get("delDeviceFromPlant", this.deletingDeviceInfo)
        .then(res => {
          if (res.err == 0) {
            // this.$message.success(this.$t("device.deleteSuc"));
            this.deletingDeviceInfo = null;
            this.delDeviceSucVisible = true;
            this.getDeviceList();
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.deviceTipMsg = this.$t(`errCode.${res.err}`);
            this.delDeviceFailVisible = true;
          }
        });
    },
    //勾选多项
    changeFun (val) {
      this.selectedAlarm = val; // 返回的是选中的列的数组集合
    },
    // 给下发指令该列增加样式
    // (row, column, rowIndex, columnIndex)
    changeCellStyle (row) {
      if (row.column.label == i18n.t("device.Send_Command")) {
        return "background: linear-gradient(0deg, rgba(60, 75, 87, 1) 5.36%, rgba(42, 54, 63, 1) 100%);box-shadow: -1px -1px 11px rgba(74, 74, 74, 0.06), 0px 4px 4px rgba(0, 0, 0, 0.25);";
      } else {
        return "";
      }
    },
    // 显示详情 =====
    showDetail () {
      this.$emit("showdetail", true);
    }
    // 获取设备信息
    // getDeviceOwnInfo() {
    //   let param = {
    //     sn: this.deviceInfo.sn,
    //     // devtype: 2304,
    //   };
    //   this.$request.get("webQueryDeviceEs", param).then(res => {
    //     if (res.err == 0) {
    //       // console.log('getDeviceInfo', res.dat.device[0]);
    //       this.deviceOwnInfo = res.dat.device[0];
    //     } else {
    //       this.$message.warning(this.$t(`errCode.${res.err}`));
    //     }
    //   });
    // },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.deviceoperate {
  padding: 8px 24px 8px 10px;
  height: 108px;
  display: flex;
  // margin-bottom: 10px;
  justify-content: space-between;
  align-items: center;
  background: rgb(34, 45, 53);
  color: #ffffff;

  // .btn {
  //   padding: 6px 12px;
  //   border-radius: 6px;
  //   font-size: 14px;
  //   cursor: pointer;
  // }
  // .btn-dark {
  //   background: @primaryTextColor;
  //   color: rgba(34, 45, 53, 1);
  //   border: none;
  // }
  // .btn-light {
  //   background: transparent;
  //   color: @primaryTextColor;
  //   border: 1px solid @primaryTextColor;
  // }
  .top-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    max-width: 45%;
    margin-top: -30px;

    .label {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      .sc(14px, #333);

      // 设备状态带阴影
      .status-icon-shadow {
        width: 14px;
        height: 14px;
        border-radius: 7px;
        margin: 0 14px 0 18px;
      }

      .status-normal-shadow {
        background-color: rgba(48, 236, 112, 1);
        box-shadow: 1px 1px 3px rgba(48, 236, 112, 1);
      }

      .status-offline-shadow {
        background-color: rgba(183, 183, 183, 1);
        box-shadow: 1px 1px 3px rgba(183, 183, 183, 1);
      }

      .status-fault-shadow {
        background-color: rgba(255, 62, 62, 1);
        box-shadow: 1px 1px 3px rgba(255, 62, 62, 1);
      }

      .status-standby-shadow {
        background-color: rgba(73, 222, 255, 1);
        box-shadow: 1px 1px 3px rgba(73, 222, 255, 1);
      }

      .status-warning-shadow {
        background-color: rgba(236, 150, 48, 1);
        box-shadow: 1px 1px 3px rgba(236, 150, 48, 1);
      }
    }

    .namebox {
      // display: block;
      // text-align: left;
      max-width: 70%;

      .name {
        display: inline-block;
        width: 100%;
        font-family: Microsoft YaHei;
        font-size: 20px;
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .ico-edit {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url(../../../../assets/img/general/Icon_Pencil.png);
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
    }
  }

  .top-operate {

    .aRowOne,
    .aRowTwo {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .todetail {
      padding: 9px 12px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 14px;
      margin-left: 12px;
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}

// 固件升级状态窗
.upgradeNew {

  .processstatue,
  .processstatueEquipment {
    font-size: 16px;
    color: #16d09a;
  }

  /deep/.el-progress__text {
    color: #ffffff;
  }

  .progerssComplete,
  .progerssCompleteEquipment {
    background: transparent;
  }
}
</style>
<style lang="less" scoped>
.deviceinfo {
  // width: 600px;
  // box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .usrBox {
    padding: 0px 30px 12px;
    display: flex;
    // margin-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    background: rgb(34, 45, 53);
    color: #ffffff;
    margin-top: -40px;
  }

  .top-operate {
    display: flex;
    // flex-direction: column;
    justify-content: space-between;
    padding: 20px 0px;
    background: rgb(34, 45, 53);
    // box-shadow: 2px 0px 11px rgba(0, 0, 0, 0.2);
    box-shadow: none;

    // /deep/.el-button + .el-button {
    //   margin-left: 0px;
    // }
    .operation {
      // width: 86px;
      // height: 32px;
      padding: 6px 12px;
      border-radius: 6px;
      border: 1px solid rgba(85, 180, 145, 1);
      box-sizing: border-box;
      background-color: @primaryButtonColor;
      color: #ffffff;
      margin-left: 12px;

      // margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }

      i {
        font-size: 18px;
        vertical-align: middle;
      }

      .icon-text1 {
        display: inline-block;
        margin-left: 6px;
      }

      // 是否关注
      .followno {
        background-image: url(../../../../assets/img/general/Icon_Operate_Follow_Light.png);
        background-size: contain;
      }

      .followyes {
        background-image: url(../../../../assets/img/general/Icon_Operate_Follow_Dark.png);
        background-size: 22px 22px;
      }

      .ico-export {
        background-image: url(../../../../assets/img/general/Icon_Operate_Export.png);
      }

      .ico-debug {
        background-image: url(../../../../assets/img/general/Icon_Operate_Debug.png);
      }

      .ico-control {
        background-image: url(../../../../assets/img/general/Icon_Operate_Control.png);
      }

      .ico-upgrade {
        background-image: url(../../../../assets/img/general/Icon_Operate_Upgrade.png);
      }

      .ico-delete {
        background-image: url(../../../../assets/img/general/Icon_Operate_Delete.png);
      }

      .icobase {
        width: 18px;
        height: 18px;
        display: inline-block;
        background-position: center;
        background-repeat: no-repeat;
        // background-size: contain;
        vertical-align: middle;
      }
    }

    .delBgc {
      border: 1px solid rgba(255, 62, 62, 1);
      background: rgba(255, 62, 62, 0.5);
      color: #ffffff;
    }
  }

  .infopanel {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
    padding-bottom: 10px;
    // .attachbox {
    //   // margin-left: 20px;
    //   padding: 0px 20px;
    //   background: transparent;
    //   color: #ffffff;
    // }
  }

  .infobox {
    display: grid;
    // width: 600px;
    width: 100%;
    box-shadow: 2px 0px 11px rgba(0, 0, 0, 0.2);
    grid-template-columns: 1fr 1fr 4px 1fr 1fr;
    grid-template-rows: 56px 56px 56px 56px 56px 56px 56px 56px;
    grid-template-areas:
      "a1 a1 a1 a1 a1"
      "a11 a12 s1 a13 a14"
      "a21 a22 s2 a23 a24"
      "a31 a32 s3 a33 a34"
      "a2 a2 a2 a2 a2"
      "a41 a42 s4 a43 a44"
      "a3 a3 a3 a3 a3"
      "a51 a52 s5 a53 a54"
    ;

    // ......................
    .aTitle1 {
      grid-area: a1;
    }

    .aCell11 {
      grid-area: a11;
    }

    .aCell12 {
      grid-area: a12;
    }

    .aCell13 {
      grid-area: a13;
    }

    .aCell14 {
      grid-area: a14;
    }

    // 
    .aCell21 {
      grid-area: a21;
    }

    .aCell22 {
      grid-area: a22;
    }

    .aCell23 {
      grid-area: a23;
    }

    .aCell24 {
      grid-area: a24;
    }

    // 
    .aCell31 {
      grid-area: a31;
    }

    .aCell32 {
      grid-area: a32;
    }

    .aCell33 {
      grid-area: a33;
    }

    .aCell34 {
      grid-area: a34;
    }

    // ......................
    .aTitle2 {
      grid-area: a2;
    }

    .aCell41 {
      grid-area: a41;
    }

    .aCell42 {
      grid-area: a42;
    }

    .aCell43 {
      grid-area: a43;
    }

    .aCell44 {
      grid-area: a44;
    }

    // ......................
    .aTitle3 {
      grid-area: a3;
    }

    .aCell51 {
      grid-area: a51;
    }

    .aCell52 {
      grid-area: a52;
    }

    .aCell53 {
      grid-area: a53;
    }

    .aCell54 {
      grid-area: a54;
    }

    // 分割竖盒
    .aCell01 {
      grid-area: s1;
    }

    .aCell02 {
      grid-area: s2;
    }

    .aCell03 {
      grid-area: s3;
    }

    .aCell04 {
      grid-area: s4;
    }

    .aCell05 {
      grid-area: s5;
    }

    // ......................
    .title {
      // grid-column: 1 / span 2;
      // grid-row: 1;
      // height: 46px;
      // line-height: 46px;
      // height: 5vh;
      line-height: 56px;
      padding: 0px 20px;
      background: rgba(65, 80, 90, 1);
      color: rgba(235, 235, 235, 1);
      font-weight: bold;
      font-size: 16px;
      position: relative;
    }

    .cell {
      // height: 57px;
      // line-height: 57px;
      // height: 6vh;
      line-height: 56px;
      padding: 0px 16px;
      // box-shadow: -1px 0px rgba(198, 209, 221, 0.5) inset;
      box-shadow: none;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      // width: 50%;
      // .celltxt {
      //   display: inline-block;
      //   // width: 100%;
      //   text-overflow:ellipsis;
      //   overflow:hidden;
      //   white-space:nowrap;
      // }
    }

    // 信息表格分割系列=====
    // 分割横线H
    .splitHLine {
      border-bottom: 1px solid rgba(198, 209, 221, 0.3);
    }

    // 分割竖线V
    // .splitVLine {
    //   border-bottom: 1px solid rgba(198,209,221,0.3);
    // }
    // 分割竖盒VBox
    .splitVBox {
      width: 4px;
      height: 100%;
      background: #222d35;
      border-left: 1px solid rgba(198, 209, 221, 0.3);
      border-right: 1px solid rgba(198, 209, 221, 0.3);
    }

    // .cellmax {
    //   max-width: 100px;
    // }
    // .name {
    //   grid-column: 1;
    //   max-width: 100%;
    // }
    .data {
      // grid-column: 2;
      max-width: 100%;
      display: inline-block;
      // width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      box-shadow: none;
    }

    .dark {
      background: rgb(34, 45, 53);
    }

    .light {
      background: rgb(43, 56, 66);
    }

    .todetail {
      // padding: 6px 12px;
      // padding: 0.5vh 12px;
      padding: 8px 12px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 14px;
      position: absolute;
      top: 13px;
      right: 12px;
      z-index: 1;
    }
  }

  // 滚动条
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }

  .el-table--border::after,
  .el-table--group::after {
    width: 0px;
  }

  .tableloding {

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: transparent;
    }

    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }

    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor !important;
    }
  }

  // 弹窗系列 =====
  // 控制弹框
  .control {
    .current-value {
      display: flex;

      .el-input {
        flex: 1;
        margin-right: 3px;
      }

      .submit-control {
        i {
          font-size: 16px;
        }

        padding: 5px 12px;
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: rgba(255, 255, 255, 1);
      }
    }

    .control-value {
      .submit-control {
        i {
          font-size: 18px;
        }
      }

      /deep/.el-button,
      /deep/.el-button:focus,
      /deep/.el-button:hover {
        background: transparent;
        border: none;
        color: @primaryTextColor;
      }
    }

    /deep/.el-input .el-input__inner {
      border: none;
    }

    /deep/.el-table th,
    /deep/.el-table tr {
      background: rgba(34, 45, 53, 1);
      color: #ffffff;
      padding: 0px 10px;
    }

    /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background: rgba(43, 56, 66, 1);
      color: #ffffff;
      border: none;
    }

    // /deep/.el-button,
    // /deep/.el-button:focus,
    // /deep/.el-button:hover {
    // 	background: transparent;
    // 	border: none;
    // 	color: @primaryTextColor;
    // }
    // 表头
    /deep/.el-table th {
      border: none;
      box-shadow: 0px 1px rgba(255, 255, 255, 0.25) inset,
        0px -1px rgba(255, 255, 255, 0.25) inset;
    }

    /deep/.el-table--border,
    /deep/.el-table--group {
      border: none;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    // 间距
    /deep/ .el-table__body {
      border-collapse: separate;
      border-spacing: 10px;
      table-layout: auto !important;
      background: rgba(34, 45, 53, 1);
    }
  }

  // 设备调试返回值
  .debug-return {
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    padding: 6px 8px;
    background: rgba(43, 56, 66, 1);

    /deep/.el-textarea__inner {
      border: none;
      background: rgba(43, 56, 66, 1);
    }

    .return-tool {
      border-top: 1px dashed rgba(204, 206, 221, 0.5);
      text-align: right;
      padding: 6px 10px 0px;
      margin-top: 5px;

      .btn:hover {
        color: @primaryTextColor;

        .ico-clear {
          background: url(../../../../assets/img/general/Icon_Debug_Delete_Dark.png);
        }

        .ico-copy {
          background: url(../../../../assets/img/general/Icon_Debug_Copy_Dark.png);
        }
      }

      .btn {
        padding: 0px;
        color: rgba(235, 235, 235, 1);
        font-size: 12px;
        cursor: pointer;
      }

      .ico-clear {
        background: url(../../../../assets/img/general/Icon_Debug_Delete.png);
      }

      .ico-copy {
        background: url(../../../../assets/img/general/Icon_Debug_Copy.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
      }
    }
  }

  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }
}
</style>

<style lang="less">
// #下拉选框 el-select#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}
</style>
